import * as types from '../actions/actionTypes';
import initialState from './initialState';
import ShallowCopyFileObject from '../../Utils/FileUtils';

export default function assetsReducer(state = initialState.assets, action) {
	//avoiding state mutation, while updating nested states.
	switch (action.type) {
		case types.ADD_ASSETS_DATA:
			return [...state, ...action.data];

		case types.UPDATE_ASSETS_DATA:
			return state.map((asset, i) => {
				if (asset.id === action.data.id) {
					return {
						...action.data,
					};
				}
				return { ...asset };
			});

		case types.REMOVE_ASSETS_DATA:
			return state.filter((asset) => asset.id !== action.data);

		case types.ADD_ASSET_FILES:
			const stateObj = state.map((asset, i) => {
				if (asset.id === action.data.id) {
					return {
						...asset,
						sourceFiles: [...asset.sourceFiles, ...action.data.sourceFiles],
					};
				}
				return { ...asset };
			});
			return stateObj;

		case types.APPLY_SELECTEDTAG_TO_ALLASSETS:
			const tag = action.data;
			return state.map((asset) => {
				const tagsAlreadyAssignedToAssets = new Set(asset.tags.map((t) => t));
				if (!tagsAlreadyAssignedToAssets.has(tag)) {
					return {
						...asset,
						tags: [...asset.tags, tag],
					};
				}
				return { ...asset };
			});

		case types.REMOVE_TAGS_FROM_ALL_ASSETS:
			return state.map((asset) => {
				return {
					...asset,
					tags: [],
				};
			});
		case types.REMOVE_TAG_FROM_ALL_ASSETS: {
			const tag = action.data;
			return state.map((asset) => {
				return {
					...asset,
					tags: [...asset.tags.filter((at) => at !== tag)],
				};
			});
		}

		case types.REMOVE_ASSET_FILE:
			const newState = state.map((asset, i) => {
				if (asset.id === action.data.id) {
					return {
						...asset,
						sourceFiles: [...asset.sourceFiles.filter((file) => file.name !== action.data.file.name)],
					};
				}
				return { ...asset };
			});
			return newState;

		case types.UPDATE_FILE_REVIEW_STATUS:
			const newAssetStateWithFiles = state.map((asset, i) => {
				if (asset.id === action.data.id) {
					return {
						...asset,
						sourceFiles: asset.sourceFiles.map((file) => {
							const shallowFileObj = ShallowCopyFileObject(file);
							if (file.name === action.data.fileName) {
								shallowFileObj.status = action.data.status;
								return shallowFileObj;
							}
							return shallowFileObj;
						}),
					};
				}
				return { ...asset };
			});
			return newAssetStateWithFiles;

		//files action types
		case types.ASSETS_JIRA_TICKET:
			const updatedAssets = state.map((asset) => {
				return {
					...asset,
					createJira: action.data,
				};
			});
			return updatedAssets;
		// Delete invalid assets(assets with no unique name on UI and backend)
		case types.DELETE_INVALID_ASSETS:
			return state.filter((asset) => asset.isAssetNameUnqiueOnUI && asset.isAssetNameUniqueInBackEnd);

		default:
			return state;
	}
}
